import './src/application_purged.css'

